import React from 'react';

import Select from 'react-select';
import { withLocaleContext } from '../../locales/locale-context.js';

import './input.field.scss';
import './select.field.scss';

const countries = require('i18n-iso-countries');
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));
countries.registerLocale(require('i18n-iso-countries/langs/pt.json'));

const CustomSelect = ({
	children, setFieldValue, name, localeContext, selectedValue, ...restProps
}) => {
	const list = Object.keys(countries.getAlpha2Codes());

	const options = list.map(key => (
		{
			value: key,
			label: countries.getName(key, localeContext.locale.value.toUpperCase() || 'PT'),
		}));

	return (
		<Select
			{...restProps}
			options={options}
			name="country"
			theme={theme => ({
				...theme,
				borderRadius: 0,
				colors: {
					...theme.colors,
					primary: '#46BED6',
				},
			})}
			styles={{
				container: () => ({
					width: '100%',
					position: 'relative',
				}),
				control: provided => ({
					...provided,
					minWidth: 150,
					width: '100%',
					height: 50,
					borderRadius: 0,
				}),
				indicatorSeparator: () => ({
					width: 0,
				}),
			}}
			onChange={value => setFieldValue(name, value)}
			value={selectedValue || null}
		/>
	);
};

export default withLocaleContext(CustomSelect);
